
import React from 'react';
import { cn } from '@/lib/utils';
import { getCategoryById } from '@/data/articles';

interface CategoryBadgeProps {
  categoryId: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showIcon?: boolean;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({
  categoryId,
  size = 'md',
  className,
  showIcon = true,
}) => {
  const category = getCategoryById(categoryId);
  
  if (!category) return null;
  
  const { name, icon: Icon, color } = category;
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  };
  
  return (
    <span 
      className={cn(
        'inline-flex items-center gap-1.5 font-medium rounded-full transition-all',
        color,
        sizeClasses[size],
        className
      )}
    >
      {showIcon && <Icon className="w-3.5 h-3.5" />}
      {name}
    </span>
  );
};

export default CategoryBadge;
